var _path, _path2, _path3, _path4, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.2958 28.056L76.8438 28.048L59.1558 37.416C59.1558 37.416 56.9318 41.276 56.8958 41.416C56.8638 41.536 57.8958 53.72 57.8958 53.72L62.6158 58.74L62.8838 86.956L62.8438 86.88V86.904L62.6758 86.704L55.5798 78.404L54.6678 75.556C54.6078 75.368 48.6398 56.676 47.5838 48.032C46.2518 37.148 44.0278 17.016 44.0078 16.816L43.6158 13.256H34.1638L33.7718 16.816C33.7478 17.02 31.5278 37.148 30.1958 48.032C29.1398 56.676 23.1718 75.368 23.1118 75.556L22.1998 78.404L14.1318 87.84L14.1758 95.16H31.4038L31.4118 114.7H46.6078L46.5558 95.16H63.5918L63.6278 89.332L63.6318 88.996L77.9678 104.736C77.9678 104.736 92.8478 104.78 92.9398 104.736C93.0558 104.684 108.068 88.652 108.068 88.652L108.12 59.264L113.136 53.6L114.016 38.632C113.952 38.504 94.2958 28.056 94.2958 28.056ZM34.1638 48.524C35.5158 37.492 37.7478 17.26 37.7478 17.26H40.0278C40.0278 17.26 42.2598 37.492 43.6118 48.524C44.7278 57.648 50.8558 76.78 50.8558 76.78H26.9198C26.9198 76.78 33.0478 57.648 34.1638 48.524ZM35.4118 110.7L35.4038 95.16H42.5558L42.5958 110.7H35.4118ZM59.6198 91.16H18.1518L18.1398 89.308L25.4118 80.804H52.3598L59.6318 89.308L59.6198 91.16ZM109.232 51.916L104.128 57.344L104.072 87.064L91.2078 100.744H83.9878H82.1838H81.0518H79.6998L74.2318 94.928L71.6838 92.22L66.8358 87.064L66.7798 57.344L61.6758 51.916L61.0238 40.952L71.4438 35.368C72.5598 34.764 74.5318 33.676 74.5318 33.676C76.2958 32.736 77.6358 32.052 77.6358 32.052C77.6358 32.052 78.9958 32.04 80.8958 32.044C81.8238 32.048 82.8838 32.048 83.9878 32.052H93.2678L109.876 40.952L109.232 51.916Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.6918 41.332L89.6478 44.384L92.9398 47.728L89.3638 51.424V54.356H92.6198L96.0398 50.88L99.4598 54.356H102.716V51.424L99.1398 47.728L102.432 44.384L102.392 41.332H99.1358L96.0398 44.528L92.9478 41.332H89.6918Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.9004 32.04L81.0524 100.744H83.9884V32.048C82.8924 32.044 81.8324 32.04 80.9004 32.04Z",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.4442 35.368L71.3042 91.808L74.2322 94.924L74.5362 33.672C74.5362 33.676 72.5602 34.764 71.4442 35.368Z",
    fillOpacity: 0.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.6399 32.048C77.6399 32.048 76.2999 32.736 74.5359 33.672L74.2319 94.924L79.6999 100.74H81.0519L80.8999 32.04C78.9999 32.036 77.6399 32.048 77.6399 32.048Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLance);
export default __webpack_public_path__ + "static/media/lance.6b2fddf301710091e6601240fd3a71b8.svg";
export { ForwardRef as ReactComponent };